import React, { useEffect, useState } from "react";
import {
  getSingleSurvey,
  addFormContent,
  updateFormContent,
  getFormContent,
  surveyResultPreview,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../api/config/apiConfig";
import Input from "../../atoms/Input";
import ContactDetailField from "../../molecules/ContactDetailField";
import "./style.css";
import { Table, Box, CircularProgress } from "@mui/material";
import DynamicText from "../../molecules/DynamicText";
import { useParams } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import removeImg from "../../../imgs/remove.png";

const WeightTicketDownload = ({ surveyData, formContent }) => {
  const { surveyId, id, flg } = useParams();

  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);

  let totalNoOfPieces = 0;
  let totalGrossWeight = 0;
  let totalNetWeight = 0;
  let totalVolWeight = 0;
  let totalCFT = 0;
  let totalCBM = 0;
  let CMS = 0;
  let totalCFTbyCBM = 0;
  let totalCMS = 0;

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <div className="premium-print-container mx-4">
      <div className="section-divider mb-3">
        <h1 className="section-title">Weight Ticket</h1>
      </div>

      {/* file detail*/}
      <div className="data-grid mb-4">
        <div className="data-item">
          <span className="data-label">Our Ref</span>
          <span className="data-value">{formContent?.refNo || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Date</span>
          <span className="data-value">{formContent?.date ? formatDate(formContent?.date) : "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Shipment Mode</span>
          <span className="data-value">{formContent?.shipmentMode || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Origin Address</span>
          <span className="data-value">{formContent?.originAddress || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Destination</span>
          <span className="data-value">{formContent?.destination || "-"}</span>
        </div>
      </div>

      <div className="mb-4">
        <p style={{ fontSize: '10pt', fontStyle: 'italic', color: '#475569' }}>
          This is to certify that the air shipment of used household goods & personal effects belonging to 
          <strong> {formContent?.belongsToA || "-"}</strong> C/O <strong>{formContent?.belongsToB || "-"}</strong> 
          at {formContent?.originAddress || "-"}.
        </p>
      </div>

      {formContent?.dataRows?.map((row, index) => {
        totalNoOfPieces = Number(totalNoOfPieces) + Number(row?.noOfPieces || 0);
        totalGrossWeight = Number(totalGrossWeight) + Number(row?.grossWeight || 0);
        totalNetWeight = Number(totalNetWeight) + Number(row?.netWeight || 0);
        totalVolWeight = Number(totalVolWeight) + Number(row?.volWeight || 0);
        totalCFT = Number(totalCFT) + Number(row?.cft || 0);
        totalCBM = Number(totalCBM) + Number(row?.cbm || 0);
        totalCMS = Number(totalCMS) + (Number(row?.length || 0) * Number(row?.width || 0) * Number(row?.height || 0));
        return null;
      })}

      <div className="section-divider mb-2">
        <h2 className="section-title" style={{ fontSize: '11pt' }}>Measurements & Weights</h2>
      </div>

      <div className="mb-4">
        <table className="w-100" style={{ borderCollapse: 'collapse', fontSize: '9pt' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              <th className="border p-2 text-start">PCS</th>
              <th className="border p-2 text-start">GROSS (KGS)</th>
              <th className="border p-2 text-start">NET (KGS)</th>
              <th className="border p-2 text-start">VOL (KGS)</th>
              <th className="border p-2 text-center" colSpan={3}>DIMENSIONS (IN)</th>
              <th className="border p-2 text-start">CFT/CBM</th>
            </tr>
          </thead>
          <tbody>
            {formContent?.dataRows?.map((row, index) => (
              <tr key={index}>
                <td className="border p-2">{row.noOfPieces || "-"}</td>
                <td className="border p-2">{row.grossWeight || "-"}</td>
                <td className="border p-2">{row.netWeight || "-"}</td>
                <td className="border p-2">{row.volWeight || "-"}</td>
                <td className="border p-2 text-center">L: {row.length || "0"}″</td>
                <td className="border p-2 text-center">W: {row.width || "0"}″</td>
                <td className="border p-2 text-center">H: {row.height || "0"}″</td>
                <td className="border p-2">{(row.cft || 0).toFixed(2)} / {(row.cbm || 0).toFixed(2)}</td>
              </tr>
            ))}
            <tr style={{ background: '#f1f5f9', fontWeight: 800 }}>
              <td className="border p-2">{totalNoOfPieces}</td>
              <td className="border p-2">{totalGrossWeight} KGS</td>
              <td className="border p-2">{totalNetWeight} KGS</td>
              <td className="border p-2">{totalVolWeight} KGS</td>
              <td className="border p-2 text-center" colSpan={3}>VOL: {totalCMS}</td>
              <td className="border p-2">{totalCFT.toFixed(2)} / {totalCBM.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Signatures */}
      <div className="mt-5 pt-4">
        <Row>
          <Col sm={6} className="text-center">
            <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
              {formContent?.weightMasterSign && (
                <img src={`${Bucket}${formContent.weightMasterSign}`} height={70} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Weight Master</p>
          </Col>
          <Col sm={6} className="text-center">
            <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
              <span style={{ fontSize: '11pt', fontWeight: 600 }}>{formContent?.weightMasterName || "-"}</span>
            </div>
            <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Approved By</p>
          </Col>
        </Row>
      </div>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert elevation={6} variant="filled" severity={snackbarMessage?.includes("successful") ? "success" : "error"} onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};
export default WeightTicketDownload;
